import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Alert from '@components/common/Alert';
import Loader from '@components/common/Loader';
import { getIdpByName } from './helpers';

// const IDP_NAME = 'custom-Fidelity-DEV';

function SsoRedirect() {
  const { shuttleRootPath: idpName } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const idp = getIdpByName(idpName);
    if (!idp) {
      return setError(`Error: no configuration found for ${idpName}`);
    }
    // eslint-disable-next-line consistent-return
    (async () => {
      try {
        const initResult = await idp.init(idpName);
        if (initResult) {
          const authorizeUrl = idp.buildAuthorizeUrlForIdp();
          window.location.replace(authorizeUrl);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        setError('Something went wrong. We are currently unable to access your experience. Please try again later.');
      }
    })();

    return () => idp?.cancelCurrentRequest();
  }, [idpName]);

  if (error) {
    return (
      <Alert
        variant="danger"
        message={error}
      />
    );
  }

  return (
    <Loader message="You are being automatically redirected to your Single Sign On Provider..." />
  );
}

export default SsoRedirect;
